import { useCallback } from "react";
import { type FieldSaveState, IDLE_FIELD_STATE } from "./types";
import type { UseInlineFieldSaveReturn } from "./useInlineFieldSave";

/**
 * Buffer-mode adapter for inline field saves on new (unsaved) documents.
 *
 * Mirrors UseInlineFieldSaveReturn but performs no network calls.
 * The actual buffer write happens in each widget's handleInlineCommit,
 * which calls onFieldChange() before calling saveField(). This hook's
 * saveField is a no-op that resolves true — the formData update is
 * already done by the time it's called.
 */
export function useBufferFieldSave(): UseInlineFieldSaveReturn {
  const saveField = useCallback(
    async (
      _fieldname: string,
      _value: unknown,
      _previousValue?: unknown
    ): Promise<boolean> => true,
    []
  );

  const getFieldState = useCallback(
    (_fieldname: string): FieldSaveState => IDLE_FIELD_STATE,
    []
  );
  const clearError = useCallback((_fieldname: string) => {}, []);
  const undoField = useCallback(
    async (_fieldname: string): Promise<boolean> => false,
    []
  );
  const retryField = useCallback(
    async (_fieldname: string): Promise<boolean> => false,
    []
  );
  const getUndoable = useCallback((_fieldname: string): boolean => false, []);

  return {
    saveField,
    getFieldState,
    clearError,
    undoField,
    retryField,
    getUndoable,
    lastSavedField: null,
  };
}
